// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UF2p","toggle":"styles_toggle__BMGi2","preview":"styles_preview__XDNIl"};